

import { Component, Vue, Prop, VModel } from 'vue-property-decorator';

@Component
export default class IBSpinner extends Vue {

	@VModel({ type: Boolean, default: false })
	readonly active!: boolean

	@Prop({ type: String, default: 'div' })
	readonly tagName!: string

	@Prop({ type: Boolean, default: false })
	readonly fullHeight!: boolean

}

